import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "forbidden-page" }
const _hoisted_2 = { class: "forbidden-card" }
const _hoisted_3 = { class: "user-info" }

import { computed, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { useAuthStore } from '@/store/auth';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ForbiddenView',
  setup(__props) {

  const authStore = useAuthStore();
  const router = useRouter();
  const loading = ref(false);

  const userText = computed(() => {
    const user = authStore.user;
    if (!user) return '';
    return user.displayName === user.username
      ? user.username
      : `${user.displayName}（${user.username}）`;
  });

  const handleLogout = async (): Promise<void> => {
    loading.value = true;
    await authStore.logout();
    await router.replace('/login');
  };

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "status-icon" }, "!", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h1", null, "暂无访问权限", -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(userText.value), 1),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "message" }, "暂无餐厅后台管理权限，请联系管理员", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "hint" }, "管理员配置角色后，请退出并重新登录。", -1)),
      _createVNode(_component_van_button, {
        block: "",
        round: "",
        type: "primary",
        loading: loading.value,
        onClick: handleLogout
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" 退出登录 ", -1)
        ])),
        _: 1,
        __: [0]
      }, 8, ["loading"])
    ])
  ]))
}
}

})